import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./campus_card_account_type.js";
//#region src/campus_card_account_type_helper.ts
var campus_card_account_type_helper_exports = /* @__PURE__ */ __exportAll({
	atriumName: () => atriumName,
	name: () => name
});
function name(accountType) {
	switch (accountType) {
		case "stored-value": return "Stored Value";
		case "meal-plan": return "Meal Plan";
		case "cash-equivalency": return "Cash Equivalency";
	}
}
/** Atrium vocabulary for the same account buckets. */
function atriumName(accountType) {
	switch (accountType) {
		case "stored-value": return "Declining Balance";
		case "meal-plan": return "Meal Exchange";
		case "cash-equivalency": return "Cash Equivalency";
	}
}
//#endregion
export { atriumName, campus_card_account_type_helper_exports, name };

//# sourceMappingURL=campus_card_account_type_helper.js.map